import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import FeaturedSolutions, { FeaturedItem } from '../components/FeaturedSolutions';
import appOndemandFood from '../assets/products/app-ondemand-food.png';
import appReservePark from '../assets/products/app-reserve-park.png';

const SpecialEventsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page splash specialEventsPage">
      <div className="background" />
      <Header />
      <div className="page-header">Special Events Venue</div>

      <div className="text-blocks">
        <div className="std-text">
          {"When it\u2019s time to celebrate a special occasion, help your residents and their families reserve the time they prefer and keep the snacks and beverages flowing with mobile POS right at their location."}
        </div>
      </div>

      <FeaturedSolutions>
        <FeaturedItem
          label="IG OnDemand"
          imgSrc={appOndemandFood}
          onClick={() => navigate('/solutions/ig-on-demand')}
        />
        <FeaturedItem
          label="Reserve"
          imgSrc={appReservePark}
          onClick={() => navigate('/solutions/reserve')}
        />
      </FeaturedSolutions>
    </div>
  );
};

export default SpecialEventsPage;
